import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Broadcasts a word the user clicked/selected inside step content so that any
 * subscriber (e.g. CompactComponent, DictionaryLookupComponent) can react —
 * typically by opening the dictionary drawer and running a lookup.
 */
@Injectable({ providedIn: 'root' })
export class WordClickService {
  private _word$ = new BehaviorSubject<string | null>(null);
  readonly word$ = this._word$.asObservable();

  setWord(word: string): void {
    this._word$.next(word);
  }

  clear(): void {
    this._word$.next(null);
  }
}
